<template>
  <div class="account-type-select clearfix">
    <div class="form-section-element" v-if="field.value">
      <h2 class="account-type-title">{{ selectedObject.name }} Membership</h2>
      <div class="account-type-subtitle">{{ selectedObject.description }}</div>
      <div class="col-lg-12">
        <hr/>
      </div>
        <div class="col-sm-3 col-xs-5">
          <div class="price-block price-block-center">
            <div v-if="selectedObject.annualFee">
            <span class="price-block-dollar">$</span>
            <span class="price-block-price">{{ selectedObject.annualFee | currency_short }}</span>
            <span class="price-block-per">/yr</span>
          </div>
          <div v-else>
            <span class="price-block-dollar">$</span>
            <span class="price-block-price">{{ selectedObject.monthlyFee | currency_short }}</span>
            <span class="price-block-per">/mo</span>
            <p class="price-info">Billed biannually</p>
          </div>
          </div>
        </div>
        <div class="col-sm-9 col-xs-7 fee-info">
          <div v-if="!selectedObject.driverCost" class="joining-fee">
            No joining fee
          </div>
          <div v-else class="joining-fee">
            ${{ selectedObject.driverCost | currency_short }} joining fee per driver
          </div>
          <div v-if="selectedObject.businessPlan">
            Setup fee: $55
          </div>
          <div v-if="selectedObject.businessPlan" class="drivers">
            <strong>Drivers allowed:</strong> {{ selectedObject.maxAccounts }} +
          </div>
          <div v-else class="drivers">
            <strong>Drivers allowed:</strong> {{ selectedObject.maxAccounts }}
          </div>
          <hr class="hr-green" />
          <div v-if="!selectedObject.businessPlan" class="pre-auth">
            Pre-authorisation: ${{ selectedObject.preAuth | currency_short }}
          </div>
          <div v-else>
            <div class="pre-auth">
              Pre-authorisation: $0*
            </div>
            <div>
              *Note that there is a <strong>${{ selectedObject.preAuth | currency_short }}</strong> pre-authorisation if you have less than {{ selectedObject.maxAccounts }} drivers on the account
            </div>
          </div>
          <div v-if="selectedObject.permalink === 'student'" class="membership-notes">
            <hr class="hr-green" />
            For student memberships we require a copy of your <strong>Drivers Licence</strong> (we accept international licences) as well as <strong>current subject enrolment</strong> or <strong>Student ID</strong>
          </div>
        </div>
        <div class="col-lg-12 rates-link">
        For a more detailed overview of rates and fees, and to compare membership options, <a v-link="{ path: '/sign-up' }">click here</a>.
        <hr/>
      </div>
    </div>
    <div class="form-group">
      <label class="col-sm-4 control-label">{{ field.label }} <span v-if="field.required" class="required">*</span></label>
      <div class="col-sm-8">
        <select v-bind:name="field.name" class="form-control" v-model="field.value">
          <option value="" disabled>Select a {{ field.singleLabel ? field.singleLabel : field.label }}</option>
          <option v-for="object in field.objects" v-bind:value="object.uuid" >{{ object[field.objectName] }}</option>
        </select>
        <span class="form-validation-error" v-show="!field.valid && field.dirty">Please select a {{ field.singleLabel ? field.singleLabel : field.label }}.</span>
        <span class="fa fa-check form-control-feedback form-control-feedback-success form-control-feedback-select" v-show="field.valid && field.dirty"></span>
        <span class="fa fa-remove form-control-feedback form-control-feedback-error form-control-feedback-select" v-show="!field.valid && field.dirty"></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AccountTypeSelectInput',
  props: {
    field: {
      type: Object,
      default () {
        return {
          label: 'Text',
          name: 'objectSelect',
          objectName: 'name',
          value: '',
          objects: []
        }
      }
    }
  },
  data () {
    return {
      fieldLength: 0,
      selectedObject: {},
      sectionLength: 0
    }
  },
  ready () {
    this.sectionLength = this.$parent.form.sections.length
    this.validateField(this.field.value)
  },
  methods: {
    validateField (val) {
      if (val) {
        this.field.dirty = true
        this.field.valid = true
        this.selectedObject = this.field.objects.find((el, i, arr) => {
          return el.uuid === val
        })
        let business = {
          name: 'businessName',
          type: 'text',
          label: 'Business Name',
          required: true,
          value: this.field.businessName,
          confirmation: true,
          valid: true,
          dirty: false
        }
        let businessAdd = {
          name: 'businessAddress',
          type: 'text',
          label: 'Business Address',
          required: true,
          value: this.field.businessAddress,
          confirmation: true,
          valid: true,
          dirty: false
        }
        let businessAbn = {
          name: 'businessAbn',
          type: 'text',
          label: 'Business ABN',
          required: true,
          value: this.field.businessAbn,
          confirmation: true,
          valid: true,
          dirty: false
        }
        let businessEmployees = {
          name: 'businessEmployees',
          type: 'number',
          label: 'Number of Employees',
          required: true,
          value: this.field.businessEmployees,
          confirmation: true,
          valid: true,
          dirty: false
        }
        if (this.selectedObject.businessPlan && this.$parent.form.sections.length === this.sectionLength) {
          this.$parent.form.sections.splice(4, 0, business)
          this.$parent.form.sections.splice(5, 0, businessAdd)
          this.$parent.form.sections.splice(6, 0, businessAbn)
          this.$parent.form.sections.splice(7, 0, businessEmployees)
        } else if (this.$parent.form.sections.length > this.sectionLength) {
          this.$parent.form.sections.splice(4, 4)
        }
      } else {
        this.field.valid = false
      }
    }
  },
  watch: {
    'field.value': function (newVal, oldVal) {
      this.validateField(newVal)
    }
  }
}
</script>



// WEBPACK FOOTER //
// AccountTypeSelectInput.vue?9d6fb2b8